import React, { useState, useContext } from "react";
import { useNavigate } from "react-router";
import AuthContext from "../context/AuthContext";
import './Form.css';

const Login = () => {
    const [formData, setFormData] = useState({ email: '', password: '' });
    const { login } = useContext(AuthContext);
    const navigate = useNavigate();

    const onChange = e => setFormData({ ...formData, [e.target.name]: e.target.value });

    const onSubmit = async e => {
        e.preventDefault();
        const success = await login(formData.email, formData.password);
        console.log("Login (Login.js): ", success);
        if (success) {
            navigate('/');
        } else {
            alert('Login failed. Please check your credentials and try again.');
        }
    };

    return (
        <div className="form-container">
            <form onSubmit={onSubmit}>
                <h2>Logowanie</h2>
                <input type="email" name="email" value={formData.email} onChange={onChange} placeholder="Email" required />
                <input type="password" name="password" value={formData.password} onChange={onChange} placeholder="Password" required />
                <button type="submit">Login</button>
            </form>
        </div>
    );
};
export default Login;